import script from "./Binghai.vue?vue&type=script&setup=true&lang=js"
export * from "./Binghai.vue?vue&type=script&setup=true&lang=js"

import "./Binghai.vue?vue&type=style&index=0&id=1bfd802c&lang=less&scoped=true"
script.__scopeId = "data-v-1bfd802c"

export default script